import Vue from "vue";
import App from "./App.vue";
import FeaturedGrid from './FeaturedGrid.vue'
import { api } from "./utils/index.js";
import router from './router'

Vue.config.productionTip = false;
 
var main = new Vue({
  router,
  render: h => h(App)
}).$mount("#coveEventDisplay");

var featured = new Vue({
  render: h => h(FeaturedGrid)
}).$mount("#coveFeaturedDisplay");